import styled from "styled-components"

export const Container = styled.div`
  position: relative;
  overflow: hidden;

  .confetti {
    border-radius: 1px;
    position: absolute;
    transition: top 6s ease, left 5s ease;
    will-change: top, left;
  }

  .confetti-red {
    background-color: #f56a2c;
  }

  .confetti-yellow {
    background-color: #fad600;
  }

  .confetti-blue {
    background-color: #00adee;
  }

  .confetti-green {
    background-color: #26b4ae;
  }
`
